const textProps = {
  icon: "fas fa-award",
  iconColor: "red",
  title: "Awarded Agency",
  description:
    "Divide details about your product or agency work into parts. A paragraph describing a feature will be enough.",
};
export default textProps;
